define('chat',['controller', 'socket', 'session', 'moment', 'header', 'visibility', 'uuid', 'tooltip-notifier', 'lib/jquery.autosize'],
function(controller, socket, session, moment, header, visibility, uuid, tooltipNotifier) {
	var pending = {};
	var messagesInAbsenceCount = 0;

	function onChatSubmitted(e) {
		if (e)
			e.preventDefault();
		var text = $('#chat-message-input').val().trim();
		if (!text)
			return;

		var message = {
			text: text,
			token: uuid.generateRandomUUID(),
			send_time: moment.utc().unix(),
			sender: {
				id: session.userID,
				name: session.user
			},
			success: false
		};
		startSendInterval(message);
		pending[message.token] = message;
		sendMessage(message);
		$('#chat-message-input').val('').trigger('autosize.resize');
		insertChatMessage(message);
	}

	function startSendInterval(message) {
		message.sendInterval = setInterval(function() {
			if (!message.success) {
				var elem = $('#chat-pending-' + message.token);
				if (!elem.hasClass('transmit-error')) {
					elem.addClass('transmit-error');
					$('<span>').addClass('transmit-error-icon')
						.attr('title', 'Diese Nachricht ist noch auf dem Transportweg')
						.text('...')
						.appendTo(elem.find('.time'));
				}
				sendMessage(message);
			}
		}, 1000);
	}

	function cancelSendInterval(token) {
		var message = pending[token];
		if (message) {
			clearInterval(message.sendInterval);
			message.success = true;
			delete pending[token];
			$('#chat-pending-' + token).remove();
		}
	}

	function sendMessage(message) {
		// success is mesasured by socket event
		$.ajax({
			url: '/chat/send',
			type: 'POST',
			dataType: 'json',
			data: {text: message.text, token: message.token}
		});
	}

	function onChatMessage(e) {
		if (e.deleted) {
			if (session.admin) {
				$('#chat-' + e.id).addClass('deleted');
			} else {
				deleteChatMessage(e.id);
			}
		} else {
			if ($('#chat-' + e.id).length == 0) {
				if (e.token && e.sender.id == session.userID)
					cancelSendInterval(e.token);
				insertChatMessage(e);
			}
		}
	}

	function insertChatMessage(message) {
		// check if the user scrolled up a bit --> then do not scrollt to bottom later
		// has to be checked before inserting anything
		var user_scrolled_up = ($(window).scrollTop() + $(window).height() != $(document).height());

		if (!message.id)
			var container = $('.pending-messages');
		else
			var container = $('.chat-log');
		var lastMessage = container.children().last();

		// if the pending area is empty, the last actual message will be the previous
		if (!lastMessage.length && !message.id)
			lastMessage = $('.chat-log li').last();

		// date (not for pending messages)
		if (message.id) {
			var date = formatDate(message.send_time);
			var isoDate = formatIsoDate(message.send_time);
			var lastDate = container.find('.date').last();
			lastDate = lastDate ? lastDate.data('date') : '';
			if (lastDate != isoDate) {
				container.append($('<li>').addClass('date').text(date).data('date', isoDate));
				// re-insert date and user if the date changed
				lastMessage = [];
			}
		}

		var id = message.id ? ('chat-' + message.id) : ('chat-pending-' + message.token);
		var time = formatTime(message.send_time);
		var elem = $('<li>')
			.addClass('chat-message')
			.attr('id', id)
			.data({ senderId: message.sender.id, time: time, id: message.id });

		// sender
		if (!lastMessage.length || message.sender.id != lastMessage.data('senderId'))
			elem.append(
				$('<span>').addClass('sender').append(
					$('<a>').attr('href', '/users/' + message.sender.id).text(message.sender.name)
				));

		// text
		var messageContent = $('<div>').addClass('message-content').appendTo(elem);
		var spanElem = $('<span>').addClass('text').appendTo(messageContent);
		if (message.display_html)
			spanElem.html(message.display_html)
		else
			spanElem.text(message.text);

		// time
		if (!lastMessage.length || time != lastMessage.data('time'))
			$('<span>').addClass('time').text(time).prependTo(messageContent);

		if (!message.id)
			elem.addClass('pending');

		if (message.id && session.admin)
			createDeleteButtons(elem);

		container.append(elem);

		if(!user_scrolled_up || message.sender.id == session.userID) //user scrolled up or user's message
			scrollToBottom();

		if (!visibility.isVisible) {
			console.log('message');
			messagesInAbsenceCount++;
			controller.setTitlePrefix('(' + messagesInAbsenceCount + ')');
		}
	}

	function deleteChatMessage(id) {
		li = $('#chat-' + id);

		// move the sender down to next message
		var nextMessage = li.next();
		if (!nextMessage.hasClass('date') && nextMessage.find('.sender').length == 0)
			li.find('.sender').prependTo(nextMessage);

		li.remove();
	}

	function formatTime(time) {
		time = moment.unix(time);
		return time.format('HH:mm');
	}

	function formatDate(time) {
		time = moment.unix(time);
		return time.format('dd, D. MMMM YYYY');
	}

	function formatIsoDate(time) {
		time = moment.unix(time);
		return time.format('YYYY-MM-DD');
	}

	function scrollToBottom() {
		var elem = $('body')[0];
		window.scrollTo(0, elem.scrollHeight);
	}

	function updateOnlineList() {
		$.get('/chat/online_users', function(response) {
			$('#online-users').html(response);
			registerBanButtonHandlers();
		});
	}

	function updateGuestCount(data) {
		// for performance and server load reasons, do not request chat/online_users here
		var count = data.guestCount;
		var text = '';
		if (count == 0) {
			$('#online-users .guests-online').remove();
			return;
		}

		if (count == 1) {
			text = '1 Gast';
		} else {
			text = count + ' Gäste';
		}
		var li = $('#online-users .guests-online');
		if (li.length) {
			li.text(text);
		} else {
			$('#online-users').append($('<li>').addClass('guests-online list-item').text(text));
		}
	}

	function onLoadMoreClicked() {
		var beforeID = $('.chat-log .chat-message').first().data('id');

		var button = $(this);
		var buttonText = "ältere Nachrichten";
		button.prop('disabled', true).text(buttonText + '...');
		$.ajax({
			url: '/chat/messages?before=' + beforeID
		}).done(function(response) {
			button.remove();
			var newMessages = $(response);

			// don't duplicate date borders
			var lastNewDate = newMessages.filter('.date').last();
			var firstOldDate = $('.chat-log .date').first();
			if (lastNewDate.length && firstOldDate.length
				&& lastNewDate.text() == firstOldDate.text())
				firstOldDate.remove();

			$('.chat-log').prepend(newMessages);
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, 'Fehler beim Laden der Nachrichten.', xhr);
			button.prop('disabled', false).text(buttonText);
		});
	}

	function onBanned(e) {
		// cancel all pending messages
		for (key in pending)
			cancelSendInterval(key);

		$('.chat-form .chat-inputs').hide();
		$('.chat-form .banned-overlay').show();
		$('.chat-form .banned-overlay').html(e.html);
	}

	function onUnbanned() {
		$('.chat-form .chat-inputs').show();
		$('.chat-form .banned-overlay').hide();
	}

	var onlineStatusSender = {
		INTERVAL: 60000,
		interval: null,
		start: function() {
			if (this.interval)
				clearInterval(this.interval);
			var self = this;
			this.sendStatus('online');
			this.interval =
				setInterval(function() {
					self.sendStatus('online');

					// remove timed-out users (they do not trigger a socket event)
					updateOnlineList();
				}, this.INTERVAL);
		},
		stop: function() {
			if (this.interval)
				clearInterval(this.interval);
			this.interval = null;
			this.sendStatus('offline');
		},
		sendStatus: function(status) {
			$.ajax('/chat/update_online_status', {
				method: 'post',
				data: { status: status }
			});
		}
	};

	// admin
	function initAdminTools() {
		if (session.admin) {
			createDeleteButtons($('.chat-messages li'));

			$('#chat-admin-toggler').click(function() {
				var enabled = $('#chat-admin-toggler').prop('checked');
				$('.chat-window').toggleClass('enable-admin-tools', enabled);
			});
			registerBanButtonHandlers();
		}
	}

	function createDeleteButtons(lis) {
		lis.each(function() {
			var textElem = $(this).find('.message-content');
			$('<button>')
				.text('x')
				.click(onDeleteClick)
				.addClass('chat-admin-tool link-button delete-chat-message-button')
				.prependTo(textElem);
		});
	}

	function onDeleteClick() {
		var button = $(this);
		var li = button.closest('.chat-message');

		if (!confirm('Diese Chat-Nachricht löschen?\n' + li.find('.text').text()))
			return;

		var id = li.data('id');
		$.ajax({
			url: 'chat/' + id + '/delete',
			type: 'POST',
			dataType: 'json'
		}).done(function() {
			li.addClass('deleted');
			button.remove();
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, 'Fehler beim Löschen.', xhr);
			button.prop('disabled', false).text('x');
		});
		button.text('x...').prop('disabled', true);
	}

	function registerBanButtonHandlers() {
		$('#online-users .ban-user-button').click(onBanClick);
	}

	function onBanClick() {
		var button = $(this);
		var user = button.closest('li').data();

		var reason = prompt('Den Benutzer ' + user.name + ' temporär vom Chat ausschließen?\nGrund (optional):');
		if (reason === null)
			return;

		$.ajax({
			url: 'chat/' + user.id + '/ban',
			type: 'POST',
			dataType: 'json',
			data: {reason: reason}
		}).done(function() {
			tooltipNotifier.showSuccess($('#online-users'), user.name + " wurde gesperrt");
			button.remove();
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, 'Ein Fehler ist aufgetreten.', xhr);
			button.prop('disabled', false).text('x');
		});
		button.text('x...').prop('disabled', true);
	}

	function onAdminEventBanned(e) {
		$('#online-users').find('li[data-id=' + e.user_id + '] button').remove();

		if($('#banned-users').find('li[data-id=' + e.user_id + ']').length == 0) { //if not event was already triggered
			if($('#banned-users').find('h3').length == 0)
				$('#banned-users').prepend($('<h3>').text('Gesperrte Benutzer'));

			$('#banned-users-list').append(e.html);
		}
	}

	function onAdminEventUnbanned(e) {
		if($('#online-users').find('li[data-id=' + e.user_id + '] .ban-user-button') == 0) { //if not event was already triggered
			var button = $('<button>');
			button.addClass('chat-admin-tool');
			button.addClass('ban-user-button');
			button.addClass('link-button');
			button.text('x');

			$('#online-users').find('li[data-id=' + e.user_id + ']').prepend(button);
			registerBanButtonHandlers();
		}

		$('#banned-users').find('li[data-id=' + e.user_id + ']').remove();

		if($('#banned-users').find('li').length == 0)
			$('#banned-users').find('h3').remove();
	}

	/**
	 * Updates the height of the fixed areas when the chat input field changes height
	 */
	function updateLayout() {
		var height = parseInt($('#chat-message-input').height());
		// 55 is initial height, 28 is initial input height
		$('.chat-window').css('padding-bottom', 55 - 28 + height);
		$('.chat-form').css('height', 5 + height);
		scrollToBottom();
	}

	visibility.on('show', function() {
		messagesInAbsenceCount = 0;
		controller.setTitlePrefix('');
	});

	controller.on('community/chat', function() {
		$('.chat-form form').submit(onChatSubmitted);
		$(window).on('resize', scrollToBottom);
		scrollToBottom();
		socket.on('chat', onChatMessage);
		socket.on('chat-online-list-changed', updateOnlineList);
		socket.on('chat-guest-count', updateGuestCount);
		socket.on('chat-banned', onBanned);
		socket.on('chat-unbanned', onUnbanned);
		socket.on('admin-chat-banned', onAdminEventBanned);
		socket.on('admin-chat-unbanned', onAdminEventUnbanned);
		onlineStatusSender.start();
		initAdminTools();
		$('.chat-window .load-more-button').click(onLoadMoreClicked);
		$('#chat-message-input').autosize({
			callback: updateLayout,
			append: '' // no newline after the text
		}).keypress(function(e) {
			if (e.which == 13 && !e.shiftKey) {
				e.preventDefault();
				onChatSubmitted();
			}
		});
	},function() {
		$(window).off('resize', scrollToBottom);
		socket.off('chat', onChatMessage);
		socket.off('chat-online-list-changed', updateOnlineList);
		socket.off('chat-guest-count', updateGuestCount);
		socket.off('chat-banned', onBanned);
		socket.off('chat-unbanned', onUnbanned);
		socket.off('admin-chat-banned', onAdminEventBanned);
		socket.off('admin-chat-unbanned', onAdminEventUnbanned);
		onlineStatusSender.stop();
	});
});

